module.exports = __webpack_public_path__ + "static/media/right-caret-white.874d0966.svg";